import React, { useEffect, useState } from "react";
import useCosmosCollections from "../../../hooks/use-cosmos-collections";
import useRecordsData from "../../../hooks/use-records-data";
import { getQueryOptions } from "./hooks/query-options";
import useWidgetSettingsByKey from "../../../hooks/use-widget-settings-by-key";
import { MACRO_KEY } from "../../../optics/defaults";
import { getUsersDetails } from "../data-helpers";
import useCosmosFields from "../../../hooks/use-cosmos-fields";
import { useUpcomingBirthdayStore } from "../../../stores/use-upcoming-birthdays-store";
import UpcomingBirthday from "../widget/UpcomingBirthday";
import useDateRanges from "./hooks/use-date-ranges";

export const WIDGET_DATA = {
  id: "important-dates",
  name: "Upcoming Birthdays",
};

function UpcomingBirthdayDataBuilder({ mode }) {
  const [users, setUsers] = useState([]);
  const [records, setRecords] = useState([]);

  const { data } = useUpcomingBirthdayStore((state) => ({
    data: state.data,
  }));

  const { titleFieldId } = data;

  const { collections } = useCosmosCollections();
  const { fields } = useCosmosFields();

  const { birthdayRange, startOrEndOfCurrentYear } = useDateRanges();

  const { isWidgetSettingsLoading, widgetSettingsData } =
    useWidgetSettingsByKey({
      enabled: true,
      key: MACRO_KEY.UPCOMING_BIRTHDAYS,
      widgetId: WIDGET_DATA.id,
    });

  const {
    exists = false,
    widget: { selectedField: selectedDatabaseFieldId = "" } = {},
  } = widgetSettingsData;

  const selectedCollections = collections.filter((clc) =>
    data.collectionId.find((collId) => String(collId) === String(clc.value))
  );

  const filters = selectedCollections.map((clc) => clc.data.filters).flat();

  const { isRecordsLoading, recordsData } = useRecordsData({
    isEnabled:
      !!selectedDatabaseFieldId &&
      !!birthdayRange?.start &&
      !!startOrEndOfCurrentYear,
    options: getQueryOptions({
      databaseFieldId: selectedDatabaseFieldId,
      birthdayRange,
      startOrEndOfCurrentYear,
      collectionFilters: filters,
    }),
  });

  useEffect(() => {
    if (!records?.length) {
      return setUsers([]);
    }

    const fetchUsersDetails = async () => {
      try {
        const users = await getUsersDetails({
          records,
          databaseFieldId: selectedDatabaseFieldId,
          fields: fields.map(({ fieldProps }) => fieldProps) || [],
          titleFieldId: titleFieldId,
        });
        setUsers(users);
      } catch (error) {
        console.log("Can not get user with details.");
        setUsers([]);
      }
    };

    fetchUsersDetails();
  }, [records, fields, titleFieldId, selectedDatabaseFieldId]);

  useEffect(() => {
    if (
      selectedDatabaseFieldId &&
      !isRecordsLoading &&
      !isWidgetSettingsLoading
    ) {
      setRecords([...(recordsData || [])]);
    }
  }, [
    recordsData,
    isRecordsLoading,
    isWidgetSettingsLoading,
    selectedDatabaseFieldId,
  ]);

  const cosmosIsNotSetup =
    (!exists || !selectedDatabaseFieldId.length) && !isWidgetSettingsLoading;

  const noUsers = !users.length && !records.length && !isRecordsLoading;

  return (
    <UpcomingBirthday
      users={users}
      loading={isRecordsLoading || isWidgetSettingsLoading}
      cosmosIsNotSetup={cosmosIsNotSetup}
      noUsers={noUsers}
      mode={mode}
    />
  );
}

export default UpcomingBirthdayDataBuilder;
